<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="file-download" /> Meest recente rapportages
    </div>
    <table class="new click-tr" v-if="files.length > 0">
      <tr
        @click="download(file.path)"
        v-for="file in files.slice(0, 6)" :key="file.id"
      >
        <td>{{toTextDate(file)}}</td>
        <td>{{file.type}}</td>
        <td class="link">
          <span class="hide-mobile">Bekijk</span>
          <awesomeIcon icon="search" />
        </td>
      </tr>
    </table>
    <div class="card-content2" v-else>U heeft nog geen rapportages...</div>
    <div class="card-bottom">
      <a class="button secondary" @click="clickReports">
        Rapportages <awesomeIcon icon="angle-right" />
      </a>
      <a class="button secondary" @click="clickDocs">
        Documenten <awesomeIcon icon="angle-right" />
      </a>
    </div>
  </div>
</template>

<script>
import {
  reject,
} from 'lodash-es';

export default {
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
    };
  },
  name: 'ReportsWidget',
  computed: {
    files() {
      return reject(this.$parent.files, (obj) => obj.type === 'Kostenoverzicht' || obj.type === 'Vergelijkende Kostenmaatstaf');
    },
  },
  methods: {
    toTextDate(file) {
      if (file.date.length === 4) {
        return file.date;
      }
      return file.date[4] === 'Q'
        ? `${file.realDate.getFullYear()} - kwartaal ${file.date[5]}`
        : `${file.realDate.getFullYear()} - ${file.realDate.toLocaleString('nl', { month: 'long' })}`;
    },
    download(file) {
      this.sdk.getFile(this.$parent.currentPort.id, file);
    },
    clickReports() {
      this.$parent.$parent.other = 'reportOverview';
      this.$store.state.currentView = 'Reports';
    },
    clickDocs() {
      this.$parent.$parent.other = 'docOverview';
      this.$store.state.currentView = 'Reports';
    },
  },
};
</script>

<style lang="scss" scoped>
  .link {
    text-align: right;
  }
  table.new {
    margin: 0 15px;
    width: calc(100% - 30px);
  }
</style>
